import React from 'react';
import ReactDOM from 'react-dom/client';
import emailjs from '@emailjs/browser';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

emailjs.init("Mo6IyGy5VQoso4O9T");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
